import { useCallback, useMemo } from 'react';
import {
  createDefaultAllocationPreferences,
  createDefaultIePreferences,
  type AllocationPreferencesUpdate,
  type IePreferencesUpdate,
  useFrontWindowPreferencesStore,
} from '@/stores/frontWindowPreferencesStore';

export const useFrontWindowAllocationPreferences = (userId?: string | null) => {
  const allocation = useFrontWindowPreferencesStore(
    useCallback(
      (state) => (userId ? state.userPreferences[userId]?.allocation : undefined),
      [userId],
    ),
  );
  const setAllocationPreferences = useFrontWindowPreferencesStore(
    (state) => state.setAllocationPreferences,
  );

  const preferences = useMemo(
    () => allocation ?? createDefaultAllocationPreferences(),
    [allocation],
  );

  const updatePreferences = useCallback(
    (update: AllocationPreferencesUpdate) => {
      if (!userId) {
        return;
      }
      setAllocationPreferences(userId, update);
    },
    [setAllocationPreferences, userId],
  );

  return {
    preferences,
    updatePreferences,
  };
};

export const useFrontWindowIePreferences = (userId?: string | null) => {
  const ie = useFrontWindowPreferencesStore(
    useCallback((state) => (userId ? state.userPreferences[userId]?.ie : undefined), [userId]),
  );
  const setIePreferences = useFrontWindowPreferencesStore((state) => state.setIePreferences);

  const preferences = useMemo(() => ie ?? createDefaultIePreferences(), [ie]);

  const updatePreferences = useCallback(
    (update: IePreferencesUpdate) => {
      if (!userId) {
        return;
      }
      setIePreferences(userId, update);
    },
    [setIePreferences, userId],
  );

  return {
    preferences,
    updatePreferences,
  };
};
